import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { AbstractControl, UntypedFormArray } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { UiKitModule } from '@serviceplan/ui-kit';
import { CustomClients } from '@thehubz/shared/branding';
import { AnyType } from '@thehubz/shared/model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[thehubzFormArrayActionButton]',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatDividerModule, UiKitModule],
  templateUrl: './form-array-action-button.component.html',
  styleUrl: './form-array-action-button.component.scss',
})
export class FormArrayActionButtonComponent {
  @Input() actionType?: 'add-n-remove' | 'single-button' | string;
  @Input() rowIndex!: number;
  @Input() controls!: AbstractControl;
  @Input() controlLength!: number;
  @Input() step: AnyType;
  @Input() stepName!: string;
  @Input() fieldName!: string;
  @Input() fieldGroup: AnyType[] = [];
  @Input() disableAdd = false;
  @Input() showDivider = true;
  @Input() selectedBuyoutRightsType? = '';
  @Input() actionIconsClasses: string[] = [];

  @Input() brandingKey!: CustomClients;

  @Output() add = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();

  // Automatically apply a wrapper class to the host
  @HostBinding('class') hostClass = 'form-array-actions-wrapper';

  CustomClients = CustomClients;

  isLastIndex(): boolean {
    const currentFormArray = this.controls.get(this.fieldName) as UntypedFormArray;
    return this.rowIndex === currentFormArray?.value?.length - 1;
  }

  canAdd(): boolean {
    return this.isLastIndex() && (!this.disableAdd || this.step?.noValidationFlag);
  }

  getDynamicClasses(): string[] {
    return [
      this.fieldName === 'domains' ? '!items-end pb-5' : '',
      this.brandingKey === CustomClients.SEAT ? '!pb-7' : '',
      this.fieldName === 'usageRights' ? '!items-start !pt-7' : '',
      ...this.actionIconsClasses,
    ];
  }
}
